import React from 'react';

import {Helmet, useNavigate, useParams} from 'views/module';

import ClientViewScene from 'views/scenes/client/detail/ClientView';
import CLIENT_SOURCES from 'views/scenes/client/client_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomClientView = () => {
  const params = useParams();
  const clientRn = params.clientRn;
  const clientReadFlag = useFlag(FLAGS.CLIENT_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (clientReadFlag.isLoading || clientReadFlag.isEnabled) return;

    navigate('/client', {replace: true});
  }, [clientReadFlag.isEnabled, clientReadFlag.isLoading, navigate]);

  if (clientReadFlag.isLoading || !clientReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Client Details (Loom)</title>
      </Helmet>
      <ClientViewScene
        clientRn={clientRn}
        clientSource={CLIENT_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomClientView;
